var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { FormBaseElement } from '@unitarius/xbpm-runtime';
import { mapElementClass, omitSpecialProperties } from '../../common/utils/element.utils';
import { InputMask } from 'primereact/inputmask';
import { ControlError } from './ControlError';
var MaskControl = /** @class */ (function (_super) {
    __extends(MaskControl, _super);
    function MaskControl() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MaskControl.prototype.elementRender = function (def) {
        var _this = this;
        var _a = def.frontOptions, mask = _a.mask, hint = _a.hint, label = _a.label, restOptions = __rest(_a, ["mask", "hint", "label"]);
        var printLabel = label || def.label;
        return def.hidden ? (null) : React.createElement("div", { className: mapElementClass(restOptions) },
            React.createElement("label", { htmlFor: def.id, title: printLabel }, printLabel),
            React.createElement(InputMask, __assign({}, omitSpecialProperties(restOptions), { key: def.id, id: def.id, disabled: def.disabled, readonly: def.readonly, mask: mask || '', value: this.value || '', tooltip: hint, onChange: function (evt) { return _this.handleChange(evt.value); }, ref: function (ref) {
                    if (ref) {
                        ref.input.onblur = _this.handleBlur;
                        ref.input.onfocus = _this.handleFocus;
                        ref.input.setAttribute('field-code', def.code);
                        ref.forceUpdate();
                    }
                } })),
            React.createElement(ControlError, { error: this.error, touched: this.touched }));
    };
    return MaskControl;
}(FormBaseElement));
export { MaskControl };
//# sourceMappingURL=Mask.js.map